function getInventoryStatus() {
  return [
    {
      value: 'IN_PROGRESS',
      labelId: 'inventory.table.situation.inProgress',
    },
    {
      value: 'DONE',
      labelId: 'inventory.table.situation.done',
    },
    {
      value: 'PROCESSING',
      labelId: 'inventory.table.situation.processing',
    },
    {
      value: 'CANCELLED',
      labelId: 'inventory.table.situation.cancelled',
    },
    {
      value: 'IMPORTING',
      labelId: 'inventory.table.situation.importing',
    },
  ];
}

export default getInventoryStatus;
